import Vue from 'vue';
import Axios, {AxiosRequestConfig} from 'axios';
import store from '@/store';
import NotificacaoModel from "@/models/notificacao.model";
import {MapActionsNotificacaoModule} from "@/store/modules/notificacao/map-actions.notificacao";

const OK = 200;

const axios = Axios.create({
    baseURL:
    process.env.VUE_APP_API_BASE_URL,
});

const axiosNotificacao = Axios.create({
    baseURL:
    process.env.VUE_APP_API_BASE_URL,
});

axios.interceptors.request.use((value: AxiosRequestConfig) => {
    if (localStorage.jwt) {
        value.headers.authorization = `Bearer ${localStorage.jwt}`;
    }
    return value;
}, (error: any) => new Error(error));

const responseSuccessHandler = response => {
    if (response.status === OK) {
        if (localStorage.jwt) {
            const idUsuarioLogado = store.get('auth/id');
            axiosNotificacao.get(`notificacoes/usuario/${idUsuarioLogado}`, {
                headers: {
                    'Authorization': `Bearer ${localStorage.jwt}`
                },
            }).then((response: any) => {
                const retorno: Array<NotificacaoModel> = response.data;
                store.dispatch(MapActionsNotificacaoModule.ATUALIZAR_NOTIFICACOES, retorno);
            })
                .catch((error: any) => {
                    console.error(error.response);
                });
        }
    }
    return response;
};

const errorHandler = error => {
    return Promise.reject(error);
};

axios.interceptors.response.use(
    (response) => responseSuccessHandler(response),
    (error) => errorHandler(error)
);

Vue.prototype.$axios = axios;
